import { gql } from '@apollo/client';

export const FETCH_MATRIX = gql`
  query GetMapping($division: UUIDInput!, $level: Int!) {
    findDivisionDependencyMatrix(division: $division, level: $level) {
      division {
        __typename
        name
        key: uuid
        locationAuxs {
          key: uuid
          name
          percentage
          supportedRevenue
          comment
          locationType
        }
        revenue: supportedRevenue
        children: productGroups {
          __typename
          key: uuid
          name
          locationAuxs {
            key: uuid
            name
            percentage
            supportedRevenue
            comment
            locationType
          }
          revenue: supportedRevenue
          children: products {
            __typename
            key: uuid
            name
            locationAuxs {
              key: uuid
              name
              percentage
              supportedRevenue
              comment
              locationType
            }
            revenue: supportedRevenue
          }
        }
      }
    }
  }
`;

export const FETCH_LEVEL_ZERO_LOCATIONS = gql`
  query fetchLevelLocations($division: UUIDInput!, $level: Int!) {
    findLocationsDependencyLevel(division: $division, level: $level) {
      division {
        uuid
        name
      }
      level
      location {
        uuid
        locationName
        locationType
      }
      locationAux {
        uuid
        locationName
        locationType
      }
      unselectedLocations {
        uuid
        locationName
        locationType
      }
    }
  }
`;

export const UPDATE_DIVISION_PERCENTAGE = gql`
  mutation updatePercentage($data: UpdateDivisionPercentageInput!) {
    updateDivisionPercentage(input: $data) {
      location {
        locationName
        uuid
      }
      locationAux {
        locationName
        uuid
      }
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const UPDATE_PRODUCT_GROUP_PERCENTAGE = gql`
  mutation updatePercentage($data: UpdateProductGroupPercentageInput!) {
    updateProductGroupPercentage(input: $data) {
      location {
        locationName
        uuid
      }
      locationAux {
        locationName
        uuid
      }
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const UPDATE_PRODUCT_PERCENTAGE = gql`
  mutation updatePercentage($data: UpdateProductPercentageInput!) {
    updateProductPercentage(input: $data) {
      location {
        locationName
        uuid
      }
      locationAux {
        locationName
        uuid
      }
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const VALIDATE_UNCHECK_LOCATION = gql`
  query validateUncheck($input: CreateDependencyInput!) {
    validateUnCheckedLocation(input: $input)
  }
`;

export const UNCHECK_LOCATION = gql`
  mutation uncheckLocation($input: CreateDependencyInput!) {
    uncheckedLocation(input: $input)
  }
`;

export const ASSESS_INTERMEDIATE_DEPENDENCIES = gql`
  query AssessIntermediateDependencies($input: AssessDependenciesInput!) {
    assessIntermediateDependencies(input: $input) {
      totalCount
      hasDependencies
      directDependenciesCount
      indirectDependenciesCount
      sampleDependencies {
        uuid
        locationName
        locationType
      }
      parentLocationMapping {
        location {
          uuid
          locationName
          locationType
        }
        dependencyId
      }
    }
  }
`;
